// extracted by mini-css-extract-plugin
module.exports = {"lia-bubble":"OccasionListForNodeWidget_lia-bubble__rN8Rs"};